import { render, staticRenderFns } from "./ProjectStage.vue?vue&type=template&id=7b464f9a&scoped=true&"
import script from "./ProjectStage.vue?vue&type=script&lang=js&"
export * from "./ProjectStage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStage.vue?vue&type=style&index=0&id=7b464f9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b464f9a",
  null
  
)

export default component.exports